import API from "./API";

export default class SystemSettingsAPI extends API {
  constructor(parameters = {}) {
    super("/SystemSettings", parameters);
  }

  setContractSettings(data) {
    return this.submit("put", `${this.endpoint}`, data);
  }

  saveCounterpartyGroup(data){
    return this.submit("post", `${this.endpoint}/SaveCounterpartyGroup`, data);
  }

  getCounterpartyGroup(){
    return this.submit("get", `${this.endpoint}/GetCounterpartyGroup`);
  }

  getContractSettings() {
    return this.submit("get", `${this.endpoint}`);
  }

  closePeriod(data) {
    return this.export('post', `${this.endpoint}/ClosePeriod`, data);
  }

  openPeriod(data) {
    return this.export('post', `${this.endpoint}/OpenPeriod`, data);
  }
}
